import { SelectedAttributeDetailsFragment } from '../saleor.tsx';

export const getAttribute = (
  attributes: readonly SelectedAttributeDetailsFragment[],
  slug: string
) => {
  const attribute = attributes.find((a) => a.attribute.slug === slug);

  return attribute;
};

export const getAttributeValue = (
  attributes: readonly SelectedAttributeDetailsFragment[],
  slug: string,
  format = (value: string) => value
) => {
  const attribute = getAttribute(attributes, slug);

  const value =
    attribute?.values[0]?.name || attribute?.values[0]?.value || attribute?.values[0]?.plainText;

  return value ? format(value) : null;
};

export const getDimensions = (attributes: readonly SelectedAttributeDetailsFragment[]) => {
  const height = getAttributeValue(attributes, 'puzzle-height');
  const width = getAttributeValue(attributes, 'puzzle-width');

  const heightUnit = attributes.find((a) => a.attribute.slug === 'puzzle-height')?.attribute.unit;
  const widthUnit = attributes.find((a) => a.attribute.slug === 'puzzle-width')?.attribute.unit;

  if (height && width) {
    if (heightUnit == widthUnit) {
      return `${height} x ${width} ${widthUnit.toLowerCase()}`;
    } else if (heightUnit && widthUnit) {
      return `${height} ${heightUnit} x ${width} ${widthUnit}`;
    } else {
      return `${height} x ${width}`;
    }
  }

  return null;
};
